import React from 'react';
import PropTypes from 'prop-types';
const propTypes = {
  /**
   * Breadcrumb links array
   **/
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Name to be displayed in breadcrumb link
     **/
    name: PropTypes.string.isRequired,
    /**
     * URL for the link
     **/
    url: PropTypes.string,
    /**
     * Function for onClick event
     **/
    onClick: PropTypes.func
  })).isRequired,
  /**
   * Higher-order component to wrap each link element
   */
  linkHOC: PropTypes.func,
  /**
   * Natural language content that appears in this component
   */
  content: PropTypes.shape({
    mainLabel: PropTypes.string,
    secondaryLabel: PropTypes.string
  }),
  /**
   * Additional custom classes for the nav element
   **/
  className: PropTypes.string,
  /**
   * ID for QA automation testing
   **/
  qaId: PropTypes.string
};
const defaultContent = {
  mainLabel: 'Breadcrumbs',
  secondaryLabel: 'You are here'
};
function Breadcrumbs(_ref) {
  let {
    breadcrumbs,
    linkHOC = link => link,
    content = {},
    className = '',
    qaId
  } = _ref;
  const c = {
    ...defaultContent,
    ...content
  };
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": c.mainLabel,
    className: className,
    "data-qa": qaId
  }, /*#__PURE__*/React.createElement("p", {
    id: "breadcrumblabel",
    className: "asc-acc-hidden"
  }, c.secondaryLabel), /*#__PURE__*/React.createElement("ol", {
    className: "asc-breadcrumbs",
    "aria-labelledby": "breadcrumblabel"
  }, breadcrumbs.map((breadcrumb, index) => {
    if (index < breadcrumbs.length - 1) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, linkHOC(/*#__PURE__*/React.createElement("a", {
        href: breadcrumb.url,
        onClick: breadcrumb.onClick
      }, breadcrumb.name)));
    } else {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement("span", {
        "aria-current": "page"
      }, breadcrumb.name));
    }
  })));
}
Breadcrumbs.propTypes = propTypes;
export default Breadcrumbs;